import BaseModule from './BaseModule.js';

class Configuration extends BaseModule {
  async paginate({ page, per_page, term }) {
    return await this.get(`back-office/configs`, { params: { page, per_page, term } });
  }

  async fetch(id) {
    return await this.get(`/back-office/configs/${id}`);
  }

  async create(config) {
    return await this.post(`/back-office/configs`, config);
  }

  async update(config) {
    return await this.put(`/back-office/configs/${config.id}`, config);
  }

  async remove(id) {
    return await this.delete(`/back-office/configs/${id}`);
  }
}

export default Configuration;
